import Http from '../core/fetch';
import {
    SEARCH_POPUP_CLOSE,
    SEARCH_POPUP_OPEN,
    SET_AVAILABLE_SEARCH_TABS,
    CLEAR_SEARCH_RESULTS_STRING,
    HIDE_SNAP_ASSISTANT_REMINDER,
    SHOW_SNAP_ASSISTANT_REMINDER,
} from './actionsNamesList';

import { addNotification } from '@components/GlobalNotification/globalNotification.actions';

function getFeatureName(feature) {
    switch (feature) {
        case 'mtd': {
            return 'MtdEnableLogin';
        }
        case 'local': {
            return 'LocalEnableLogin';
        }
        case 'flavor': {
            return 'FlavorPermissionId';
        }
        case 'scores': {
            return 'ScoresEnableLogin';
        }
        case 'firefly': {
            return 'FireflyEnableLogin';
        }
        case 'social': {
            return 'DatassentialOneSocialDataPermissionId';
        }
        case 'brandPerformances': {
            return 'FingerprintsEnableLogin';
        }
        case 'chains': {
            return 'SnapFeaturesFireflyChainsId';
        }
        default: {
            return '';
        }
    }
}

export function closeSearchPopup() {
    document.body.style.overflow = '';
    return {
        type: SEARCH_POPUP_CLOSE
    };
}

export function openSearchPopup() {
    document.getElementById('search_popup_input').focus();
    document.body.style.overflow = 'hidden';
    return {
        type: SEARCH_POPUP_OPEN
    };
}

export function showSnapAssistantReminder() {
    return {
        type: SHOW_SNAP_ASSISTANT_REMINDER
    };
}

export function hideSnapAssistantReminder() {
    return {
        type: HIDE_SNAP_ASSISTANT_REMINDER
    };
}

export function setAvailableSearchTabs(data) {
    return {
        type: SET_AVAILABLE_SEARCH_TABS,
        data
    };
}

export function clearSearchString() {
    return {
        type: CLEAR_SEARCH_RESULTS_STRING
    };
}

export function requestTrialByFeature(feature) {
    return () => {
        const featureName = getFeatureName(feature);
        if (!feature) return '';
        return Http.get('request by feature name', {
            feature: featureName
        });
    };
}

export function sendMobileSnapLinkOnEmail() {
    return (dispatch) => {
        return Http.post('send mail with pocket snap link', {}, {
            body: '',
        }, 'none')
        .then(() => {
            dispatch(addNotification({ text: "We've sent you email", duration: 4000 }));
        })
        .catch(err => console.log(err));
    };
}
